import { render, staticRenderFns } from "./DashboardReceivedArchiveRecordings.vue?vue&type=template&id=73f863e5&scoped=true"
import script from "./DashboardReceivedArchiveRecordings.vue?vue&type=script&lang=js"
export * from "./DashboardReceivedArchiveRecordings.vue?vue&type=script&lang=js"
import style0 from "./DashboardReceivedArchiveRecordings.vue?vue&type=style&index=0&id=73f863e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f863e5",
  null
  
)

export default component.exports